/**
 * @generated SignedSource<<422d1c77c9ecbf3070621cc54e31d0bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versions_nativeIssueTable_VersionsCell$data = {
  readonly name: string;
  readonly selectedVersionsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "versions_nativeIssueTable_VersionsCell";
};
export type versions_nativeIssueTable_VersionsCell$key = {
  readonly " $data"?: versions_nativeIssueTable_VersionsCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"versions_nativeIssueTable_VersionsCell">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versions_nativeIssueTable_VersionsCell",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraMultipleVersionPickerField"
};
})();

(node as any).hash = "56f60cdf44500ce5fad5ee491fa776bb";

export default node;
